import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { MouseEventHandler } from "react";
import "./styles.scss";

type NewBtnPropType = {
  handleBtnClick: MouseEventHandler<HTMLButtonElement>;
  title: string;
  type: "contained" | "outlined" | "text" | undefined;
  removeIcon?: boolean; 
  icon?: any;
  [key: string]: any;
};

const NewButton = ({
  handleBtnClick,
  title = "",
  type = "contained",
  removeIcon = false,
  icon,
  ...restProps
}: NewBtnPropType) => {
  return (
    <Button
      variant={type}
      color="primary"
      className={type === "outlined" ? "new-btn-outlined" : "new-btn"}
      onClick={handleBtnClick}
      component="button"
      {...restProps} 
    >
      {!removeIcon && <AddIcon className="add-icon" />}
      {icon && icon}
      {title}
    </Button>
  );
};

export default NewButton;
